/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpHeaders, HttpXsrfTokenExtractor } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class RequestHeaderInterceptorService implements HttpInterceptor {
  constructor(private tokenExtractor: HttpXsrfTokenExtractor) {}

    private actions: string[] = ["POST", "PUT", "DELETE"];
    private forbiddenActions: string[] = ["HEAD", "OPTIONS"];
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var customHeaders = new HttpHeaders({
      'Access-Control-Allow-Origin': location.origin,
      'Cache-Control': 'no-cache, no-store',
      'Pragma': 'no-cache',
      'Expires': '0'
    });
    req = req.clone({ headers: customHeaders,withCredentials: true });
    // if(req.url.startsWith(environment.apiUrl)){
    //   //clear cookie
    //   // document.cookie = "XSRF-TOKEN" + "=;expires=" + new Date(0).toUTCString();
    //   let token = this.tokenExtractor.getToken();
    //   let permitted =  this.findByActionName(req.method, this.actions);
    //   let forbidden =  this.findByActionName(req.method, this.forbiddenActions);;

    //   if (permitted !== undefined && forbidden === undefined && token !== null) {
    //     req = req.clone({ setHeaders: { "X-XSRF-TOKEN": token } });
    //   }
    // }
    
    return next.handle(req);
  }
  private findByActionName(name: string, actions: string[]): string {
    return actions.find(action => action.toLocaleLowerCase() === name.toLocaleLowerCase());
}
}
